import React from "react";
import { useTheme } from "@material-ui/core/styles";
import { Box, Typography } from "@mui/material";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { dashboardColors, isDashboardDark } from "./dashboardTheme";

const DonutWithLegend = ({ title, data, height = 260 }) => {
  const theme = useTheme();
  const isDark = isDashboardDark(theme);
  const colors = dashboardColors(isDark);
  const total = data.reduce((sum, item) => sum + (Number(item.value) || 0), 0);

  const chartData = data.filter((item) => Number(item.value) > 0);
  const displayData = chartData.length > 0 ? chartData : [{ name: "—", value: 1, color: isDark ? "#334155" : "#e2e8f0" }];

  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1.5, color: colors.text }}>
        {title}
      </Typography>
      <Box sx={{ position: "relative", height, width: "100%" }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={displayData}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              innerRadius={58}
              outerRadius={88}
              paddingAngle={chartData.length > 1 ? 4 : 0}
              strokeWidth={0}
            >
              {displayData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            {chartData.length > 0 && (
              <Tooltip
                formatter={(value, name) => [value, name]}
                contentStyle={{
                  borderRadius: 10,
                  border: isDark ? "1px solid rgba(148,163,184,0.2)" : "1px solid rgba(15,23,42,0.08)",
                  backgroundColor: isDark ? "#1e293b" : "#fff",
                  color: colors.text,
                }}
                itemStyle={{ color: colors.text }}
                labelStyle={{ color: colors.textSoft }}
              />
            )}
          </PieChart>
        </ResponsiveContainer>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
            pointerEvents: "none",
          }}
        >
          <Typography variant="h5" fontWeight={700} lineHeight={1} sx={{ color: colors.text }}>
            {total}
          </Typography>
          <Typography variant="caption" fontWeight={600} sx={{ color: colors.textSoft }}>
            Total
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 1 }}>
        {data.map((item) => (
          <Box key={item.name} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
              <Box sx={{ width: 10, height: 10, borderRadius: "50%", bgcolor: item.color, flexShrink: 0 }} />
              <Typography variant="body2" noWrap sx={{ color: colors.textSoft }}>
                {item.name}
              </Typography>
            </Box>
            <Typography variant="body2" fontWeight={700} sx={{ color: colors.text }}>
              {item.value}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default DonutWithLegend;
